import React, { Component }  from 'react';
import './LoadingView.scss';

class LoadingView extends Component {
  static defaultProps = {
  }

  state = {
  }

  componentWillMount = () => {
  }

  componentDidMount = () => {

  }
  render() {
    const {style, icon, width} = this.props;
    let _width = width || '2rem';
    return (<div className='loading_view_container' style={style}>
      <img alt='' style={{ width: _width, height: _width }} src={ icon || require('../assets/loading.gif')}></img>
      {/* <div className='loading_view_text'>未找到相关内容</div> */}
    </div>);
  }
}

export default LoadingView;

